var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('img',{attrs:{"src":require("@/assets/images/home/wss-img.png"),"alt":"图片加载异常"}}),_c('p',[_c('span',{staticClass:"iconfont icon-xiaolian"}),_c('i',[_vm._v("|")]),_vm._v(" 欢迎使用AIRPLEX(埃力克斯)订货系统~")])])
}]

export { render, staticRenderFns }